/** @jsxImportSource theme-ui */
import { Formik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { usePostTicketMutation } from '@/store/apiService';
import TicketForm, { TicketFormValues } from './TicketForm';
import { validateTicket } from './common';

const CreateTicket: React.FC = () => {
    const { companyId } = useParams<{ companyId?: string }>();
    const [createTicket, createTicketState] = usePostTicketMutation();
    const navigate = useNavigate();

    const initialValues: TicketFormValues = {
        CompanyId: companyId ?? '',
        Title: '',
        Description: '',
        CaseTypeId: 0,
        CaseAreaId: 0,
    };

    return (
        <Formik
            initialValues={initialValues}
            validate={validateTicket}
            onSubmit={(values, { setSubmitting }) => {
                const payload = {
                    CompanyId: values.CompanyId,
                    Title: values.Title,
                    Description: values.Description,
                    CaseTypeId: Number(values.CaseTypeId),
                    CaseAreaId: Number(values.CaseAreaId),
                };
                createTicket(payload)
                    .unwrap()
                    .then((created) => {
                        if (created?.Id != null) {
                            navigate(`/tickets/${created.Id}`);
                        } else {
                            navigate('/tickets');
                        }
                    })
                    .catch((err) => {
                        setSubmitting(false);
                        toast.error(err?.data ?? err?.message ?? 'Create failed', {
                            autoClose: 5000,
                        });
                    });
            }}
        >
            {(formProps) => (
                <TicketForm
                    mode="create"
                    additionalErrors={createTicketState.error}
                    {...formProps}
                />
            )}
        </Formik>
    );
};

export default CreateTicket;
